export const PLP_PRODUCTS = {
  SET_ALL_PLP_PRODUCTS: "setAllPlpProducts",
  SET_PLP_PRODUCTS: "setPlpProducts",
  SET_PRODUCT_LIST_INFO: "setProductListInfo",
  SET_PLP_CACHED_DATA: "setPlpCachedData",
  SET_PRODUCTS_SKUs: "setProductsSKUs"
};
